import { Component } from '@angular/core';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { NGXLogger } from 'ngx-logger';
import { RoutingUtils } from 'src/app/routing/routing.utils';
import { GtmEvent } from '../services/analytics/analytics.types';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor(
    private analyticsService: AnalyticsService,
    private logger: NGXLogger,
    private routingUtils: RoutingUtils
  ) {}

  element(pageElement: string): string {
    const element = this.analyticsService.elementNameForRoute(
      this.routingUtils.appRouteFromPath(window.location.pathname),
      pageElement
    );
    this.logger.debug('element', element);
    return element;
  }

  contactSupportClick() {
    const element = this.element('Footer Support');
    this.analyticsService.pushEvent('contact_support', {
      category: 'Link Click',
      action: 'Outbound Link',
      element,
    });
  }

  contactInfoClick() {
    const element = this.element('Footer Connect');
    this.analyticsService.pushEvent('footer_connect_email', {
      category: 'Button Click',
      action: 'Outbound Link',
      element,
    });
  }
}
